import { render, staticRenderFns } from "./event-nav.vue?vue&type=template&id=1b8ad4ee&scoped=true"
import script from "./event-nav.vue?vue&type=script&lang=js"
export * from "./event-nav.vue?vue&type=script&lang=js"
import style0 from "./event-nav.vue?vue&type=style&index=0&id=1b8ad4ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ad4ee",
  null
  
)

export default component.exports